import { useToast } from '@wwe-portal/ui/components/toast';
import { useCallback } from 'react';

import { useTranslations } from 'next-intl';
import { XsollaPaymentError } from '../../libs/xsolla/type';

export const useHandleXsollaPayment = () => {
  const t = useTranslations();
  const { toast } = useToast();
  return useCallback(
    (error: unknown) => {
      let isHandled = false;
      let isCancelled = false;
      let status: XsollaPaymentError['status'] | undefined;
      if (error instanceof XsollaPaymentError) {
        status = error.status;
      }
      // Xsolla widget is closed after loaded
      if (error instanceof XsollaPaymentError && error.status === 'cancelled') {
        isHandled = true;
        isCancelled = true;
      }

      // Xsolla widget is closed before loaded
      if (error instanceof XsollaPaymentError && error.status === 'closed') {
        isHandled = true;
        isCancelled = true;
      }

      if (error instanceof XsollaPaymentError && error.status === 'failed') {
        isHandled = true;
        toast({ variant: 'error', content: t('transaction_failure') });
      }

      return {
        isHandled,
        isCancelled,
        status,
      };
    },
    [toast, t]
  );
};
